import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  makeStyles,
  Tooltip,
  Button,
  Grid,
  Typography,
  DialogTitle,
  Divider,
  TextField,
  FormControl,
  Paper,
  Box,
  IconButton,
  FormControlLabel,
  Fab,
  InputLabel,
  Select,
  MenuItem,
  ButtonGroup,
  Checkbox,
  Tab,
} from "@material-ui/core";
import {TabContext, TabList, TabPanel} from '@material-ui/lab';

import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import CreateIcon from '@material-ui/icons/Create';
import { useDispatch, useSelector } from "react-redux";
import {updatePlan, submitPlan, getPlansByUser, getPlan, getPlans, setPlanDraft} from "../../../actions/fallProtectionAction";
import {getLocations, getUsers} from "../../../actions/usersAction";
import Feedback from "../../../utils/Feedback";
import { Autocomplete } from "@material-ui/lab";
import PlanSignatureModal from "./PlanSignatureModal";
import SketchModal from "./SketchModal";

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    padding: theme.spacing(6),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2),
    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },

  title: {
    fontSize: 13,
  },
  title2: {
    fontSize: 13,
    marginBottom: 10,
    fontWeight: "bold",

    },

  time: {
    // marginLeft: "auto",
    marginTop: 10,

    // width: 120,
    width: "fit-content",
    height: 40,
    padding: theme.spacing(1),
    // textAlign: "center",
    margin: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  icon: {
    marginRight: 5,
  },
  btn: {
    padding: theme.spacing(1.5),
    marginTop: 30,
    marginBottom: 30,
    width: 300,
    [theme.breakpoints.down("sm")]: {
        width: "50%",
      },
    [theme.breakpoints.down("xs")]: {
    width: "100%",
    }
  },

  btn2:{
    marginBottom: 30,
    marginLeft: 10
  },
  dialog: {
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      height: "100%",
    },
  },
  formControl: {
    minWidth: 760,
    [theme.breakpoints.down("sm")]: {
      minWidth: 640,
    },
    [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
    }
},
formControl2: {
  textAlign: "left",
  minWidth: 370,
  [theme.breakpoints.down("sm")]: {
    minWidth: 310,
  },
  [theme.breakpoints.down("xs")]: {
    minWidth: "100%",
  },
},

leftAlign: {
  textAlign: "left",
},

  paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
  },
  [theme.breakpoints.down("sm")]: {
      width: "100%",
  },
  [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
  },
  fab: {
      right: theme.spacing(-1),
  },
  tab: {
    marginTop: 10,
    marginBottom: 10,
    [theme.breakpoints.down("sm")]: {
      display:"block",
      lineHeight: 1.5,
    }
  },

  tabPanel: {
    width: 300,
    marginTop: 30,
    marginBottom: 30,
  },
  typo : {
    fontWeight: "bold",
    fontSize: 13,
  },
  sign : {
    width: 60,
    height: 30,
    [theme.breakpoints.down("sm")]: {
      width: 60,
      height: 30,
    },
    [theme.breakpoints.down("xs")]: {
      width: 40,
      height: 20,
    },
  },

  sketch : {
    width: 500,
    height: 400,
    [theme.breakpoints.down("sm")]: {
      width: 500,
      height: 400,
    },
    [theme.breakpoints.down("xs")]: {
      width: 400,
      height: 200,
    },
  },

}));

const INIT_STATE = {
    planner: "",
    ert: "",
    supervisor: undefined,
    safety:"",
    date: "",
    location: undefined,
    radio: false,
    cell:false,
    verbal:false,
    meetingPoint: "",
    personToSecure: "",
    personnelTrained: "",
    readiness: "",
    awp: false,
    ladder: false,
    scaffold: false,
    crane: false,
    other: false,
    otherDescription: "",
    haveAlternative: false,
    workersTrained: false,
    equipmentAppropriate: false,
    discussedWithCrew: false,
    equipmentInspected: false,
    traumaStraps: false,
    workerFallPlan: "",
    workArea: "",
    reviews: [{ name: "", signature: "", date: "" }],
    
};

const EditPlanModal = ({ openEditPlan, handleCloseEditPlan, id }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [state, setState] = useState(INIT_STATE);
  const [feed, setFeed] = React.useState({
    loading: false,
    open: false,
    message: "",
    success: false,
  });

  const { fallProtection, error, loading } = useSelector((state) => state.fallprotection);
  const { profile, locations, users } = useSelector((state) => state.users);
  const [val, setVal] = useState('1');
  const [openSignatureModal, setOpenSignatureModal] = useState(false);
  const [openSketchModal, setOpenSketchModal] = useState(false);
  const [getId, setGetId] = useState("");

  let isAdminGuard = profile
    ? (profile &&
        profile.role && profile.role.map((role) => role.name).includes("admin"))
    : false;

    let isPlanAdmin = profile
    ? (profile &&
        profile.role && profile.role.map((role) => role.name).includes("plan_admin"))
        : false;

  useEffect(() => {
    dispatch(getPlansByUser());
    dispatch(getLocations());
    dispatch(getUsers());
    }, [dispatch]);

  useEffect(() => {
    const abortController = new AbortController();
    if (error && error !== null) {
      setFeed((prev) => ({
        loading: false,
        open: true,
        message: error,
        success: false,
      }));
    }
    return () => {
      abortController.abort();
    };
  }, [error]);

  useEffect(() => {
    if (id){
      dispatch(getPlan(id));
    }
    
  }, [dispatch, id]);
 
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      planner: fallProtection?.planner,
      ert: fallProtection?.ert,
      supervisor: fallProtection?.supervisor,
      safety: fallProtection?.safety,
      date: fallProtection?.date,
      location: fallProtection?.location._id,
      radio: fallProtection?.radio,
      cell: fallProtection?.cell,
      verbal: fallProtection?.verbal,
      meetingPoint: fallProtection?.meetingPoint,
      personToSecure: fallProtection?.personToSecure,
      personnelTrained: fallProtection?.personnelTrained,
      readiness: fallProtection?.readiness,
      awp: fallProtection?.awp,
      ladder: fallProtection?.ladder,
      scaffold: fallProtection?.scaffold,
      crane: fallProtection?.crane,
      other: fallProtection?.other,
      otherDescription: fallProtection?.otherDescription,
      haveAlternative: fallProtection?.haveAlternative,
      workersTrained: fallProtection?.workersTrained,

      equipmentAppropriate: fallProtection?.equipmentAppropriate,
      discussedWithCrew: fallProtection?.discussedWithCrew,
      equipmentInspected: fallProtection?.equipmentInspected,
      traumaStraps: fallProtection?.traumaStraps,
      workerFallPlan: fallProtection?.workerFallPlan,
      workArea: fallProtection?.workArea,
      reviews: fallProtection?.reviews,


    }));
  }, [fallProtection]);

   const handleSetDraft = (e) => {
      e.preventDefault();
      dispatch(setPlanDraft(id));
      setTimeout(() => {
        handleCloseEditPlan();
          dispatch(getPlans());
          dispatch(getPlansByUser());
  
          setFeed((prev) => ({
            loading: false,
            open: true,
            message: "Plan Set to Draft Successfully!",
            success: true,
          }));
      }, 1500);
    };

  const handleChange = (e) => {
    e.persist();
    setState((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
    
  };

  const handleChangeReview = (index) => (e) => {
      e.persist();
      const { name, value } = e.target;
      const list = [...state.reviews];
      list[index][name] = value;
      setState((prevState) => ({ ...prevState, reviews: list }));
    };
  
    const handleAddReview = (e) => {
      e.persist();
      const data = {
          name: "",
          signature: "",
          date: "",
      }
      setState((prevState) => ({ ...prevState, reviews: [...prevState.reviews, data] }))
  
      let currentState = {
          reviews: [...state.reviews, data],
          id
      };
  
      dispatch(updatePlan(currentState));
      setTimeout(() => {
          dispatch(getPlan(id))
        }, 1500);
    };
  
    const handleRemoveReview = (index) => (e) => {
      e.persist();
      const list = [...state.reviews];
      list.splice(index, 1);
      setState((prevState) => ({ ...prevState, reviews: list }));
    };
  
    const handleOpenSignature = (id) => {
      setGetId(id);
      setOpenSignatureModal(true);
    };
  
    const handleCloseSignature = () => {
      setOpenSignatureModal(false);
    };

    const handleOpenSketch = (id) => {
      setGetId(id);
      setOpenSketchModal(true);
    };

    const handleCloseSketch = () => {
      setOpenSketchModal(false);
    };

  

  const handleSave = async (e) => {
    e.preventDefault();
    let data = {
      planner: state.planner,
      ert: state.ert,
      supervisor: state.supervisor,
      safety: state.safety,
      date: state.date,
      location: state.location,
      radio: state.radio,
      cell: state.cell,
      verbal: state.verbal,
      meetingPoint: state.meetingPoint,
      personToSecure: state.personToSecure,
      personnelTrained: state.personnelTrained,
      readiness: state.readiness,
      awp: state.awp,
      ladder: state.ladder,
      scaffold: state.scaffold,
      crane: state.crane,
      other: state.other,
      otherDescription: state.otherDescription,
      haveAlternative: state.haveAlternative,
      workersTrained: state.workersTrained,
      equipmentAppropriate: state.equipmentAppropriate,
      discussedWithCrew: state.discussedWithCrew,
      equipmentInspected: state.equipmentInspected,
      traumaStraps: state.traumaStraps,
      workerFallPlan:state.workerFallPlan,
      workArea:state.workArea,
      reviews: state.reviews,
      id

    };
    try {
      await dispatch(updatePlan(data));
      handleCloseEditPlan();
      dispatch(getPlansByUser());
      setFeed((prev) => ({
        loading: false,
        open: true,
        message: "Plan Saved Successfully.",
        success: true,
      }));
    } catch (err) {
      setFeed((prev) => ({
        ...prev,
        loading: false,
        open: true,
        message: err.message || "Failed to save plan.",
        success: false,
      }));
    }
  };

  const handleSubmitPlan = async (e) => {
    e.preventDefault();
    let data = {
        planner: state.planner,
        ert: state.ert,
        supervisor: state.supervisor,
        safety: state.safety,
        date: state.date,
        location: state.location,
        radio: state.radio,
        cell: state.cell,
        verbal: state.verbal,
        meetingPoint: state.meetingPoint,
        personToSecure: state.personToSecure,
        personnelTrained: state.personnelTrained,
        readiness: state.readiness,
        awp: state.awp,
        ladder: state.ladder,
        scaffold: state.scaffold,
        crane: state.crane,
        other: state.other,
        otherDescription: state.otherDescription,
        haveAlternative: state.haveAlternative,
        workersTrained: state.workersTrained,
        equipmentAppropriate: state.equipmentAppropriate,
        discussedWithCrew: state.discussedWithCrew,
        equipmentInspected: state.equipmentInspected,
        traumaStraps: state.traumaStraps,
        workerFallPlan:state.workerFallPlan,
        workArea:state.workArea,
        reviews: state.reviews,
        path: "fall-protection/plan/view",
        id
    };
    try {
      await dispatch(submitPlan(data));
      handleCloseEditPlan()
        dispatch(getPlansByUser());
        setFeed((prev) => ({
          loading: false,
          open: true,
          message: "Plan Submitted Successfully.",
          success: true,
        }));
    } catch (err) {
      setFeed((prev) => ({
        ...prev,
        loading: false,
        open: true,
        message: err.message || "Failed to submit plan.",
        success: false,
      }));
    }
  };

  const handleTabChange = (event, newVal) => {
    setVal(newVal);
  };

  const handleCloseFeed = () => {
    setFeed((prevState) => ({ ...prevState, open: false }));
  };

  const isValid = () =>
    !state.planner || !state.location

  return (
    <div>
      <PlanSignatureModal {...{ openSignatureModal, handleCloseSignature, id: getId }} />
      <SketchModal {...{ openSketchModal, handleCloseSketch, id: getId }} />
      {feed.success ? (
        <Feedback
          handleCloseFeed={handleCloseFeed}
          open={feed.open}
          severity="success"
          message={feed.message}
        />
      ) : (
        <Feedback
          handleCloseFeed={handleCloseFeed}
          open={feed.open}
          severity="error"
          message={feed.message}
        />
      )}
      <Dialog
        open={openEditPlan}
        onClose={handleCloseEditPlan}
        fullWidth
        maxWidth="md"
        className={classes.dialog}

      >
        <DialogTitle>
        
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="overline" className={classes.title}>
                Edit Fall Protection Rescue/Assist Plan
              </Typography>
            </Grid>
            <Grid item>
              <Tooltip arrow title="Close">
                <IconButton onClick={handleCloseEditPlan}>
                  <CloseIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </DialogTitle>
        <Divider />
        <Grid container justifyContent="space-between" alignItems="center">
            {(fallProtection && fallProtection.status === "Submitted") && (isAdminGuard || isPlanAdmin) && (
            <Grid item xs={5} sm={4}>
                <ButtonGroup className={classes.btnGroup} variant="outlined">
                    <Button
                        size="small"
                        className={classes.btnLink}
                        color="primary"
                        onClick={handleSetDraft}
                    >
                        Set to Draft
                    </Button>
                
                </ButtonGroup>
            </Grid>
            )}
          </Grid>
        
        <DialogContent className={classes.dialogContent}>
          <Paper className={classes.paper} variant="outlined">
            <Box sx={{ width: '100%', typography: 'body1' }}>
              <TabContext value={val}>
                  <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                      <TabList onChange={handleTabChange} textColor="secondary" indicatorColor="secondary">
                      <Tab label="Plan Information" className={classes.tab} value="1"/>
                      <Tab label="Sketch/Sign"  className={classes.tab} value="2"/>
                      </TabList>
                  </Box>
                  <TabPanel value="1">
                      <Grid container justifyContent="center" alignItems="center" spacing={3}>
                          <Grid item xs={12} sm={6}>
                              <TextField
                                  name="date"
                                  fullWidth
                                  variant="outlined"
                                  label="Date"
                                  onChange={handleChange}
                                  value={state.date?.split("T")[0] || ""}
                                  required
                                  type="date"   
                              />
                          </Grid>
                          <Grid item xs={12} sm={6} >
                              <FormControl variant="outlined" className={classes.formControl2} required>
                                  <InputLabel id="demo-simple-select-outlined-label">
                                      Location
                                  </InputLabel>
                                  <Select
                                  labelId="demo-simple-select-outlined-label"
                                  id="demo-simple-select-outlined"
                                  fullWidth
                                  value={state.location || ""}
                                  name="location"
                                  onChange={handleChange}
                                  label="Location"
                                  >
                                  <MenuItem value={null}>
                                      <em>None</em>
                                  </MenuItem>
                                  {locations &&
                                      locations.map((location) => (
                                      <MenuItem key={location._id} value={location._id}>
                                          {location.displayname}
                                      </MenuItem>
                                      ))}
                                  </Select>
                              </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6} className={classes.leftAlign}>
                              <Grid item xs={12} sm={12} md={12}>
                                  <h3>Contacts</h3>
                              </Grid>
                              <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    name="planner"
                                    fullWidth
                                    variant="outlined"
                                    label="Planner"
                                    value={state.planner}
                                    onChange={handleChange}
                                    required
                                />
                              </Grid>
                              <br />
                              <Grid item xs={12} sm={12} md={12}>
                                  <TextField
                                      name="ert"
                                      fullWidth
                                      variant="outlined"
                                      label="ERT"
                                      onChange={handleChange}
                                      value={state.ert || ""}
                                  />
                              </Grid>
                              <br />
                              <Grid item xs={12} sm={12} md={12}>
                                  <FormControl className={classes.formControl2}>
                                      <Autocomplete 
                                        id="supervisor"
                                        options={users}
                                        getOptionSelected={(option, value) => option.displayname === state.supervisor?.displayname}
                                        getOptionLabel={(option) => option.displayname || ''} 
                                        onChange={(e, value) => setState((prevState) => ({ ...prevState, supervisor: value }))}
                                        value={state.supervisor || ''}
                                        renderInput={(params) => 
                                        <TextField {...params} variant="outlined" label="Supervisor" />} 
                                    />
                                  </FormControl>
                              </Grid>
                              <br />
                              <Grid item xs={12} sm={12} md={12}>
                                  <TextField
                                      name="safety"
                                      fullWidth
                                      variant="outlined"
                                      label="Safety"
                                      onChange={handleChange}
                                      value={state.safety || ""}
                                  />
                              </Grid>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className={classes.leftAlign}>
                              <Grid item xs={12} sm={12} md={12}>
                                  <h3>Personnel Roles</h3>
                              </Grid>
                              <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    name="meetingPoint"
                                    fullWidth
                                    variant="outlined"
                                    label="Meeting Point"
                                    onChange={handleChange}
                                    value={state.meetingPoint || ""}
                                />
                              </Grid>
                              <br />
                              <Grid item xs={12} sm={12} md={12}>
                                  <TextField
                                      name="personToSecure"
                                      fullWidth
                                      variant="outlined"
                                      label="Person to Secure the Area"
                                      onChange={handleChange}
                                      value={state.personToSecure || ""}
                                  />
                              </Grid>
                              <br />
                              <Grid item xs={12} sm={12} md={12}>
                                  <TextField
                                      name="personnelTrained"
                                      fullWidth
                                      variant="outlined"
                                      label="Personnel Trained on AWP"
                                      onChange={handleChange}
                                      value={state.personnelTrained || ""}
                                  />
                              </Grid>
                              <br />
                              <Grid item xs={12} sm={12} md={12}>
                                  <TextField
                                      name="readiness"
                                      fullWidth
                                      variant="outlined"
                                      label="Location/Readiness of AWP (Keys, Fuel, etc.)"
                                      onChange={handleChange}
                                      value={state.readiness || ""}
                                  />
                                </Grid>

                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className={classes.leftAlign}>
                              <Grid item xs={12} sm={12} md={12}>
                                  <h3>Method of Communication</h3>
                              </Grid>
                              <Grid item xs={12} sm={12} md={12}>
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={state.radio || false}
                                        name="radio"
                                        color="primary"
                                        onChange={(e, value) => {
                                        e.persist()
                                        setState((prevState) =>({ ...prevState, radio: value }))
                                        }}
                                    />
                                    }
                                    label="Radio"
                                    labelPlacement="end"
                                />      
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={state.cell || false}
                                        name="cell"
                                        color="primary"
                                        onChange={(e, value) => {
                                        e.persist()
                                        setState((prevState) =>({ ...prevState, cell: value }))
                                        }}
                                    />
                                    }
                                    label="Cell"
                                    labelPlacement="end"
                                />      
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={state.verbal || false}
                                        name="verbal"
                                        color="primary"
                                        onChange={(e, value) => {
                                        e.persist()
                                        setState((prevState) =>({ ...prevState, verbal: value }))
                                        }}
                                    />
                                    }
                                    label="Verbal"
                                    labelPlacement="end"
                                />       
                              </Grid>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6} className={classes.leftAlign}>
                              <Grid item xs={12} sm={12} md={12}>
                                  <h3>Rescue Equipment</h3>
                              </Grid>
                              <Grid item xs={12} sm={12} md={12}>
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={state.awp || false}
                                        name="awp"
                                        color="primary"
                                        onChange={(e, value) => {
                                        e.persist()
                                        setState((prevState) =>({ ...prevState, awp: value }))
                                        }}
                                    />
                                    }
                                    label="AWP"
                                    labelPlacement="end"
                                />
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={state.ladder || false}
                                        name="ladder"
                                        color="primary"
                                        onChange={(e, value) => {
                                        e.persist()
                                        setState((prevState) =>({ ...prevState, ladder: value }))
                                        }}
                                    />
                                    }
                                    label="Ladder"
                                    labelPlacement="end"
                                />      
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={state.scaffold || false}
                                        name="scaffold"
                                        color="primary"
                                        onChange={(e, value) => {
                                        e.persist()
                                        setState((prevState) =>({ ...prevState, scaffold: value }))
                                        }}
                                    />
                                    }
                                    label="Scaffold"
                                    labelPlacement="end"
                                />
                                
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={state.crane || false}
                                        name="crane"
                                        color="primary"
                                        onChange={(e, value) => {
                                        e.persist()
                                        setState((prevState) =>({ ...prevState, crane: value }))
                                        }}
                                    />
                                    }
                                    label="Crane"
                                    labelPlacement="end"
                                />
                                
                                <FormControlLabel
                                    control={
                                    <Checkbox
                                        checked={state.other || false}
                                        name="other"
                                        color="primary"
                                        onChange={(e, value) => {
                                        e.persist()
                                        setState((prevState) =>({ ...prevState, other: value }))
                                        }}
                                    />
                                    }
                                    label="Other"
                                    labelPlacement="end"
                                />
                              
                                {state.other && (
                                  <TextField
                                      name="otherDescription"
                                      fullWidth
                                      variant="outlined"
                                      label="Other Description"
                                      onChange={handleChange}
                                      value={state.otherDescription || ""}
                                  />
                                )}

                              </Grid>
                          </Grid>
                          <Grid item xs={12} sm={12} md={12} className={classes.leftAlign}>
                              <Grid item xs={12} sm={12} md={12}>
                                  <h3>Pre Work Tasks</h3>
                              </Grid>
                            <Grid item xs={12} sm={12} md={12}>
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={state.haveAlternative || false}
                                    name="haveAlternative"
                                    color="primary"
                                    onChange={(e, value) => {
                                    e.persist()
                                    setState((prevState) =>({ ...prevState, haveAlternative: value }))
                                    }}
                                />
                                }
                                label="Have alternatives to using fall protection equipment been considered?"
                                labelPlacement="end"
                            />
                            </Grid>
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={state.workersTrained || false}
                                    name="workersTrained"
                                    color="primary"
                                    onChange={(e, value) => {
                                    e.persist()
                                    setState((prevState) =>({ ...prevState, workersTrained: value }))
                                    }}
                                />
                                }
                                label="Are all workers trained in fall protection (2 day WHSCC approved)?"
                                labelPlacement="end"
                            />      
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={state.equipmentAppropriate || false}
                                    name="equipmentAppropriate"
                                    color="primary"
                                    onChange={(e, value) => {
                                    e.persist()
                                    setState((prevState) =>({ ...prevState, equipmentAppropriate: value }))
                                    }}
                                />
                                }
                                label="Is fall protection equipment appropriate for the job (100% tie off, painter's harness/lanyard, welder's harness/lanyard)?"
                                labelPlacement="end"
                            />
                            
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={state.discussedWithCrew || false}
                                    name="discussedWithCrew"
                                    color="primary"
                                    onChange={(e, value) => {
                                    e.persist()
                                    setState((prevState) =>({ ...prevState, discussedWithCrew: value }))
                                    }}
                                />
                                }
                                label="Have you discussed with the crew how you are planning to rescue a co-worker/self-rescue?"
                                labelPlacement="end"
                            />
                            
                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={state.equipmentInspected || false}
                                    name="equipmentInspected"
                                    color="primary"
                                    onChange={(e, value) => {
                                    e.persist()
                                    setState((prevState) =>({ ...prevState, equipmentInspected: value }))
                                    }}
                                />
                                }
                                label="Has fall protection equipment been inspected?"
                                labelPlacement="end"
                            />

                            <FormControlLabel
                                control={
                                <Checkbox
                                    checked={state.traumaStraps || false}
                                    name="traumaStraps"
                                    color="primary"
                                    onChange={(e, value) => {
                                    e.persist()
                                    setState((prevState) =>({ ...prevState, traumaStraps: value }))
                                    }}
                                />
                                }
                                label="Does each harness have 2 trauma straps in good condition, are workers familiar with them?"
                                labelPlacement="end"
                            />

                          </Grid>
                          <Grid item xs={12} sm={12} md={12}>
                              <TextField
                                  name="workerFallPlan"
                                  fullWidth
                                  variant="outlined"
                                  label="Brief Description of Your Plan if a Worker Falls (Assisted or Self Rescue)"
                                  onChange={handleChange}
                                  value={state.workerFallPlan || ""}
                                  multiline
                                  minRows={6}
                              />
                            </Grid>
                          
                      </Grid>
                      <br />
                      <br />
                      <Typography align="center">
                          
                        <Button
                          color="primary"
                          variant="contained"
                          size="large"
                          onClick={handleSave}
                          className={classes.btn2}
                          disabled={isValid() || loading}
                        >
                        {loading ? "Loading..." : "Save"}
                        
                          </Button>
                      </Typography>
                      
                  </TabPanel>
                  <TabPanel value="2">
                    <Grid container justifyContent="center" alignItems="center" spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <Paper className={classes.paper} variant="outlined" square>
                                <Grid container justifyContent="center" alignItems="center" spacing={2}>
                                  
                                    <Grid item xs={12} sm={12}>
                                        <Typography variant="subtitle2" align="center">
                                            Sketch Your Work Area and How You Will Self Rescue
                                        </Typography>
                                        <br />
                                        <Grid item xs={12} sm={12}>
                                            <img src={state.workArea} alt="sketch" className={classes.sketch} />
                                        </Grid>
                                        <br />  

                                    </Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Button
                                            variant="contained"
                                            size="large"
                                            onClick={handleOpenSketch}
                                            className={classes.btn2}
                                            disabled={loading}
                                        >
                                            {loading ? "Loading..." : "Sketch"}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>

                    <br />

                    {state.reviews && state.reviews?.length > 0 && (
                    <Grid item xs={12} sm={12}>
                        <Paper className={classes.paper} variant="outlined" square>
                            {state.reviews?.map((item, index) => (
                            <Grid container justifyContent="center" alignItems="center" spacing={2} key={index}>
                                <Grid item xs={6} sm={4} md={4}>
                                  <TextField
                                      name="name"
                                      fullWidth
                                      variant="outlined"
                                      label="Name"
                                      onChange={handleChangeReview(index)}
                                      value={item.name}
                                      size="small"
                                  />
                                </Grid> 
                                
                                <Grid item xs={2} sm={1} md={1}>
                                  <Tooltip title="Click to Sign">
                                    <IconButton
                                      color="primary"
                                      onClick={() => handleOpenSignature(index)}
                                    >
                                      <CreateIcon />
                                    </IconButton>
                                  </Tooltip>
                                </Grid>
                                <Grid item xs={4} sm={3} md={3}>
                                  <img src={item.signature} alt="signature" className={classes.sign} />
                                </Grid>
                                
                                <Grid item xs={6} sm={3} md={3}>
                                    <TextField
                                      name="date"
                                      fullWidth
                                      variant="outlined"
                                      label="Date"
                                      onChange={handleChangeReview(index)}
                                      value={item.date?.split("T")[0] || ''}
                                      size="small"
                                      type="date"   
                                    />
                                </Grid>     
                                <Grid item xs={2} sm={1} md={1}>
                                    <IconButton color="secondary" onClick={handleRemoveReview(index)}>
                                        <CloseIcon />
                                    </IconButton>
                                </Grid>
                                
    
                            </Grid>
                            ))}
    
                        </Paper>
                    </Grid>
                    )}
                    <Grid item xs={12} sm={12}></Grid>
                      <Typography variant="subtitle2">
                          Click to Add Name/Signature
                      </Typography>
                      <Fab color="primary" aria-label="add" size="medium" onClick={handleAddReview} className={classes.fab}>
                          <AddIcon />
                      </Fab>
                
                <br />
                <br />
                    <Typography align="center">
                        <Button
                          variant="contained"
                          size="large"
                          onClick={handleSave}
                          className={classes.btn2}
                          disabled={isValid() || loading}
                        >
                            {loading ? "Loading..." : "Save"}
                        </Button>
                        <Button
                            color="primary"
                            variant="contained"
                            size="large"
                            onClick={handleSubmitPlan}
                            className={classes.btn2}
                            >
                            {loading ? "Loading..." : "Save & Submit Plan"}
                        </Button>
                    </Typography>
                      
                  </TabPanel>
              </TabContext>
            </Box>
          </Paper>


        </DialogContent>
      </Dialog>
    </div>
  );
};

export default EditPlanModal;
